<template>
  <div id="container">
    <div
      class="item-box-content"
      style="position:relative;padding:14px 20px;">
      <div class="title-font-style">
        <span>账号管理</span>
      </div>
      <div style="position: absolute;top:14px;right:20px;">
        <el-checkbox
          v-model="flag"
          @change="showActiveAccount"
          style="color:#83878A ">仅显示启用账号
        </el-checkbox>
      </div>
    </div>
    <!-- 账号管理搜索框 -->
    <div class="search-style">
      <el-form :inline="true">
        <el-row :gutter="24">
          <el-col :span=20>
            <el-form-item style="margin-right: 10px !important;">
              <el-input
                v-model="ruklepasm.staffName"
                placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item style="margin-right: 10px !important;">
              <el-select
                v-model="ruklepasm.jobName"
                clearable
                placeholder="请选择角色">
                <el-option
                  v-for="(item,index) in roleParams"
                  :key="index"
                  :label="item.roleName"
                  :value="item.roleName"
                >{{item.roleName}}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-right: 10px !important;">
              <el-input
                v-model="ruklepasm.staffCnName"
                placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                @click="onSearch"
                type="primary">搜索
              </el-button>
              <el-button @click="reset">重置</el-button>
            </el-form-item>
          </el-col>
          <el-col
            :span="4"
            style="text-align:right;">
            <el-form-item>
              <el-button
                type="primary"
                plain
                @click="openshow">新增员工
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 账号管理表格 -->
    <div
      class="item-box-content"
      style="margin-bottom: 0;">
      <div class="pb20">
        <el-table
          border
          ref="tableRef"
          :data="queryParams"
          tooltip-effect="dark"
          :height="tableHeight"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            label="序号"
            type="index"
            width="100px"></el-table-column>
          <el-table-column
            prop="staffCnName"
            label="员工姓名"></el-table-column>
          <el-table-column
            prop="staffName"
            label="账号"></el-table-column>
          <el-table-column
            prop="staffMobilePhone"
            label="手机号码"></el-table-column>
          <el-table-column
            prop="staffEmail"
            label="邮箱"></el-table-column>
          <el-table-column
            prop="jobName"
            label="角色"></el-table-column>
          <el-table-column
            prop="orgName"
            label="所属部门"></el-table-column>
          <el-table-column label="注册时间">
            <template slot-scope="scope">{{scope.row.createDate|dateFilter}}</template>
          </el-table-column>
          <el-table-column label="操作">
            <template scope="scope">
              <div
                class="approval line-limit-length"
                @click="updateItemS(scope.row)">修改
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="flag"
            label="是否启用"
            width="200px">
            <template slot-scope="scope">
              <el-switch
                :active-value="1"
                @change="update(scope.row)"
                :inactive-value="0"
                v-model="scope.row.flag"
              ></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :total="total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
    <!-- 新增员工信息 -->
    <!-- <add-percentage-information ref="addEditBrandRefs"></add-percentage-information> -->
    <el-dialog
      title="员工信息"
      :visible.sync="addDialogVisible"
      width="888px"
      :before-close="colseAddnewAccount">
      <div
        class="updateInfo"
        v-if="!isfromStateus">账号信息
      </div>
      <!-- 内容主体 -->
      <el-form
        :model="addForm"
        ref="addFormRef"
        :rules="ruleForm"
        label-width="90px">
        <el-row
          :gutter="30"
          style="margin-left:20px">
          <el-col :span="11">
            <el-form-item
              prop="staffName"
              label="账号：">
              <el-input
                v-model="addForm.staffName"
                :disabled="!isfromStateus"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item
              prop="staffCnName"
              label="员工姓名：">
              <el-input
                v-model="addForm.staffCnName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row
          :gutter="30"
          style="margin-left:20px">
          <el-col
            :span="11"
            v-if="isfromStateus">
            <el-form-item
              prop="password"
              label="密码： ">
              <el-input
                auto-complete="new-password"
                v-model="addForm.password"
                :type="isopeneyspasseword?'password':'text'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="11"
            v-if="!isfromStateus">
            <el-form-item
              label="邮箱："
              prop="staffEmail">
              <el-input v-model="addForm.staffEmail"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item
              prop="staffMobilePhone"
              label="手机号码：">
              <el-input v-model="addForm.staffMobilePhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="30"
          style="margin-left:20px;margin-bottom: 10px"
          v-if="isfromStateus">
          <el-col :span="11">
            <el-form-item
              label="邮箱："
              prop="staffEmail">
              <el-input v-model="addForm.staffEmail"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :span="30"
          style="margin-left: 20px;"
          v-for="(item,idx) in addForm.permiassion"
          :key="idx">
          <!-- {{addForm}} -->
          <el-col :span="11">
            <el-form-item
              label-width="105px"
              style="position:relative;overflow:hidden"
              prop="department"
            >
              <span style="position:absolute;left: -105px;top:0;width:105px;text-align: right;"><span style="color: #F56C6C;margin-right: 5px;">*</span>所属部门：</span>
              <el-cascader
                popper-class="popwerSelectex"
                style="width:266px !important;"
                :options="options"
                v-model="item.orgIdsmains.orgId"
                @change="loadcurRole"
                class="elselect"
                :props="{ value: 'id', label: 'name',children:'childList',multiple: false,checkStrictly:true,expandTrigger: 'hover'}"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item
              label-width="111px"
              style="position:relative;"
              prop="roles"
            >
              <span style="position:absolute;left: -105px;top:0;width:105px;text-align: right;"><span style="color: #F56C6C;margin-right: 5px;">*</span>角色：</span>
              <div style="position: relative;">
                <el-select
                  @change="changeRole"
                  v-model="item.rolemains.roleId">
                  <el-option
                    v-for="(itemex,indexs) in item.rolemains.roleParams"
                    :label="itemex.roleName"
                    :value="itemex.id"
                    :key="indexs"
                  ></el-option>
                </el-select>
              </div>
              <el-button
                style="color: #D35E5E !important;"
                v-if="item.rolemains.isdel && addForm.permiassion.length > 1"
                type="text"
                @click="deleteClick(idx)"
                class="deletebtn">
                删除
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :span="30"
          style="margin-left:20px">
          <!-- <el-col > -->
          <el-col
            :span="11"
            style="margin-left:20px;font-size:14px;color:#276CFF">
            +&nbsp;
            <span
              @click="tosaveAddClick"
              v-cust>添加</span>
          </el-col>
          <!-- </el-col> -->
        </el-row>
        <!-- {{isfrom}} -->
        <div
          class="updateInfo_password"
          v-if="!isfromStateus">
          <span class="updateInfo">密码修改</span>
          <el-row :span="30">
            <el-col :span="11">
              <div
                class="updatepassword"
                style="width:100%">
                <el-form-item
                  prop="nexpassword"
                  label="请输入新密码："
                  label-width="140px">
                  <el-input
                    v-model="addForm.nexpassword"
                    type="password"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="11">
              <div class="updatepassword">
                <el-form-item
                  prop="newpassword"
                  label="请确认密码："
                  label-width="138px">
                  <el-input
                    v-model="addForm.newpassword"
                    type="password"
                    style="width:97%"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="AddEmployee('addFormRef')">确 定</el-button>
        <el-button @click="closeAccountDialog">取 消</el-button>
      </span>
    </el-dialog>
    <base-dialog
      :dialog-visible.sync="accountDialog"
      @successEv="accountSuc"
      @cancelEv="accountFail"
      @closedialogVisibale="accountFail">
      <template>
        <span style="padding:0 0 20px 30px">确定禁用此账号吗？</span>
      </template>
    </base-dialog>
  </div>
</template>
<script>
  import axios from 'axios'
  import { expressionList } from '@/components/utils/data'
  import { encode64, formatDate, isSuccess } from '@/util/tool'
  import pagination from '@/components/pagination'
  import { cloneDeep, isEmpty } from 'loadsh'
  import {
    getRoleList,
    updataStatus,
    getgroupList,
    getUserInfo,
    updateUserInfo,
    getGrouoRole
  } from '@/api/system/rightsManagement.js'
  import { deepClone } from '@/util'

  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  export default {
    components: {
      pagination
    },
    data () {
      var checkName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('账号不能为空'))
        } else {
          callback()
        }
      }
      var checkstaffCnName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('姓名不能为空'))
        } else {
          callback()
        }
      }
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
      var checkpassword = (rule, value, callback) => {
        // if(!this.isfromStateus) callback()
        if (!value) {
          return callback()
        } else {
          if (value.length < 8) {
            callback(new Error('密码不可小于8位'))
          } else if (value.length > 16) {
            callback(new Error('密码不可大于16位'))
          } else if (!reg.test(value)) {
            callback(new Error('密码至少要包含数字,字符，字母中的两种'))
          } else {
            callback()
          }
        }
      }
      var validatePass2 = (rule, value, callback) => {

        // callback()
        if (!value) {
          callback()
        } else if (!reg.test(value)) {
          callback(new Error('密码必须在8-16位之间,并且包含数字字母'))
        } else if (value !== this.addForm.nexpassword) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      const checkstaffMobilePhone = (rule, value, callback) => {
        const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!myreg.test(value)) {
          callback(new Error('请输入正确的手机号码'))
        } else {
          callback()
        }
      }
      const checkstaffEmail = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('邮箱不能为空'))
        } else {
          callback()
        }
      }
      const checkroleId = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('角色不能为空'))
        } else {
          callback()
        }
      }
      const checkorgId = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('部门不能为空'))
        } else {
          callback()
        }
      }

      return {
        isfromStateus: false,
        accountDialog: false,
        dynamicValidateForm: {
          domains: [
            {
              key: 1,
              value: ''
            }
          ],
          email: ''
        },
        isopeneyspasseword: true,
        isnewpassword: true,
        // groupList:[],
        options: [],
        isfrom: 1,
        infotemp: ['staffName', 'jobName', 'staffCnName', 'flag'],
        roleParams: [],
        queryParams: [],
        ruleForm: {
          staffName: [{
            validator: checkName,
            trigger: 'blur',
            required: true
          }],
          staffCnName: [
            {
              validator: checkstaffCnName,
              trigger: 'blur',
              required: true
            }
          ],
          newpassword: [
            {
              validator: validatePass2,
              trigger: 'blur',
              required: false
            }
          ],
          nexpassword: [
            {
              validator: checkpassword,
              trigger: 'blur',
              required: false
            }
          ],
          password: [
            {
              trigger: 'blur',
              required: true,
              validator: checkpassword
            }
          ],
          staffMobilePhone: [
            {
              validator: checkstaffMobilePhone,
              trigger: 'blur',
              required: true
            }
          ],
          orgId: [
            {
              validator: checkorgId,
              trigger: 'blur',
              required: true
            }
          ],
          roleId: [
            {
              validator: checkroleId,
              trigger: 'blur',
              required: true
            }
          ]
        },
        addForm: {
          staffName: '',
          staffCnName: '',
          password: '',
          staffMobilePhone: '',
          staffEmail: '',
          permiassion: [{
            orgIdsmains: {
              label: '所属部门:',
              orgId: '',
              Id: 'orgId'
            },
            rolemains: {
              label: '角色:',
              roleId: '',
              Id: 'roleId',
              btnTitle: '删除'
            }
          }],
        },
        isupdate: [],
        ruklepasm: {
          staffName: '',
          jobName: '',
          staffCnName: '',
          flag: 1
        },
        flag: true,
        queryCriteriaVo: {
          criteriaVoList: [
            {
              collection: false,
              column: 'flag',
              endValue: '',
              expression: '',
              value: 1,
              valueType: ''
            }
          ],
          queryPageName: ''
        },
        params: {},
        contractScreenCondition: [],
        expressionList: expressionList,
        loadingTable: false, // 列表loading
        list: [{}], // 列表数据
        size: 30, // 页数
        page: 1, // 页码
        total: 0, // 列表总数
        drawer: false,
        selective: '',
        addDialogVisible: false,
        editDialogVisible: false,
        addFormRules: {},
        curAccountRow: {},
        tableHeight: window.innerHeight - 385
      }
    },
    created () {
      this.getRoleList()
      this.EmployeesList()
      this.getAddGroup()
    },
    methods: {
      accountSuc () {
        const { sbId } = this.curAccountRow
        this.updateAccountStatus(sbId, 0)
      },
      accountFail () {
        const { sbId } = this.curAccountRow
        this.EmployeesList()
      },
      colseAddnewAccount (done) {
        try {
          this.$refs.addFormRef.resetFields()
        } catch (e) {
          console.log(e)
        }
        this.addForm = {}
        done()
      },
      closeAccountDialog () {
        try {
          this.$refs.addFormRef.resetFields()
        } catch (e) {
          console.log(e)
        }
        this.addForm = {}
        this.addDialogVisible = false
      },
      changeRole (data) {
        // debugger
        const { roleId } = this.addForm
        this.addForm.roleId = (roleId || '') + (roleId ? `,${data}` : data)
      },
      showActiveAccount (data) {
        this.ruklepasm.flag = Number(data)
        if (data) {
          this.onSearch()
        } else {
          this.reset()
        }
      },
      loadcurRole (data) {
        const len = data.length
        const { orgId, permiassion } = this.addForm
        const id = data[len - 1]
        this.addForm.orgId = (orgId || '') + (orgId ? `,${data[len - 1]}` : data[len - 1])
        getGrouoRole(id).then(res => {
          if (isSuccess(res)) {
            const index = permiassion.findIndex(item => {
              const l = item.orgIdsmains.orgId[item.orgIdsmains.orgId.length - 1]
              return l === id
            })
            if (index !== -1) {
              this.$set(this.addForm.permiassion[index].rolemains, 'roleParams', res.data.obj)
              this.$set(this.addForm.permiassion[index].rolemains, 'roleId', '')
            }
          }
        })
      },
      //添加列表操作
      tosaveAddClick () {
        this.addForm.permiassion.push({
          orgIdsmains: {
            label: '所属部门:',
            orgId: '',
            Id: 'orgId',
            isdel: true
          },
          rolemains: {
            label: '角色:',
            roleId: '',
            Id: 'orgId',
            isdel: true
          }
        })
      },
      //删除列表操作
      deleteClick (idx) {
        this.addForm.permiassion.splice(idx, 1)
      },
      getPathByKey (value, key, arr) {
        const temppath = []

        // try {
        function getNodePath (node) {
          temppath.push(node.id)
          if (node[key] === value) {
          }
          if (node.childList && node.childList.length > 0) {
            for (var i = 0; i < node.childList.length; i++) {
              getNodePath(node.childList[i])
            }
            temppath.pop()
          } else {
            temppath.pop()
          }
        }

        for (let i = 0; i < arr.length; i++) {
          getNodePath(arr[i])
        }
      },
      getSelectItem (data, item) {
        const tt = []
        item.forEach((v, i) => {
          // let idnex=data.find()
          data.forEach(items => {
            const a = items.childList && items.childList.find(i => i === v)
            if (a) {
              tt.push([items.id, v])
            } else {
              tt.push(v)
            }
          })
        })
      },
      async updateItemS (row) {
        const rowex = deepClone(row)
        // this.openshow()
        this.isfrom = 2
        this.addDialogVisible = true
        const { orgId, roleId } = rowex
        const { roleParams } = this
        const roleIds = roleId && roleId.split(',')

        rowex.permiassion = []
        if (orgId) {
          orgId && orgId.split(',').forEach(async (ids, idx) => {
            rowex.permiassion[idx] = {}
            rowex.permiassion[idx].orgIdsmains = {
              label: '所属部门:',
              orgId: Number(ids),
              Id: 'orgId'
            }
            let res = await getGrouoRole(Number(ids))
            let rx = []
            if (isSuccess(res)) {
              rx = res.data.obj || []
            }
            rowex.permiassion[idx].rolemains = {
              label: '角色:',
              roleId: (roleIds && Number(roleIds[idx])) || '',
              Id: 'roleId',
              btnTitle: '删除',
              isdel: true,
              roleParams: rx
            }
            this.addForm = cloneDeep(rowex)
          })
        }
        this.isfromStateus = false
      },
      getTreeData (data) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].childList.length < 1) {
            // children若为空数组，则将children设为undefined
            data[i].childList = undefined
          } else {
            // children若不为空数组，则继续 递归调用 本方法
            this.getTreeData(data[i].childList)
          }
        }
        return data
      },
      openshow () {
        this.isfromStateus = true
        this.isfrom = 1
        this.addForm = {
          staffName: '',
          staffCnName: '',
          password: '',
          staffMobilePhone: '',
          staffEmail: '',
          permiassion: [{
            orgIdsmains: {
              label: '所属部门:',
              orgId: '',
              Id: 'orgId'
            },
            rolemains: {
              label: '角色:',
              roleId: '',
              Id: 'roleId',
              btnTitle: '删除'
            }
          }]
        }
        this.addDialogVisible = true
        this.isopeneyspasseword = true
        this.isnewpassword = true
      },
      async getAddGroup () {
        const resposne = await getgroupList()
        if (resposne.data.code === 200) {
          this.options = this.getTreeData(
            resposne.data.obj.newComOrganizationList[0].childList
          )
        }
      },
      reset () {
        const {
          flag
        } = this
        this.ruklepasm = {}
        this.queryCriteriaVo = {
          criteriaVoList: [],
          queryPageName: ''
        }
        if (flag) {
          this.queryCriteriaVo.criteriaVoList.push({
            collection: false,
            column: 'flag',
            endValue: '',
            expression: '',
            value: 1,
            valueType: ''
          })
        }
        this.EmployeesList()
      },
      update (row) {
        const { sbId, flag } = row
        this.curAccountRow = cloneDeep(row)
        if (!flag) {
          this.accountDialog = true
          return
        }
        this.updateAccountStatus(sbId, flag)
      },
      updateAccountStatus (sbId, flag) {
        updataStatus(sbId, flag).then(res => {
          this.$message({
            message: res.data.msg,
            type: res.data.code === 200 ? 'success' : 'error'
          })
          this.EmployeesList()
        })
      },
      async getRoleList () {
        const { page } = this
        const resposne = await getRoleList(page, 5000)
        this.roleParams = resposne.data.obj.records
      },
      // 查询员工列表数据
      async EmployeesList () {
        this.loadingTable = true
        const { data: res } = await this.$axios.post(
          `/api/staffBase/querySystemStaffBase/${this.page}/${this.size}`,
          this.queryCriteriaVo
        )
        // 刷缓存
        this.$axios.get('/api/auth/rebuildUserPowerAndMenu')
        if (res.code === 200) {
          this.queryParams = res.obj.records
          this.total = res.obj.total
          this.loadingTable = false
        }
      },
      // 新增员工信息
      async AddEmployee () {
        const { permiassion } = this.addForm
        this.$refs.addFormRef.validate(async valid => {
          if (valid) {
            if (permiassion.length === 0) {
              this.$message.error('请选择账号所属部门角色')
              return
            }
            if (!permiassion.every(item => item.orgIdsmains.orgId)) {
              this.$message.error('请完善账号所属部门信息')
              return
            }
            if (!permiassion.every(item => item.rolemains.roleId)) {
              this.$message.error('请完善账号所属角色信息')
              return
            }
            const departids = []
            const roleids = []
            const { isfrom } = this
            this.addForm.permiassion.forEach(item => {
              const { rolemains, orgIdsmains } = item
              const orgid = orgIdsmains.orgId
              roleids.push(rolemains.roleId)
              departids.push(Array.isArray(orgIdsmains.orgId) ? orgid[orgid.length - 1] : orgid)
            })
            const addForm = {
              createDate: '',
              createIp: 0,
              createUser: '',
              editDate: '',
              editIp: 0,
              editUser: '',
              flag: true,
              id: this.addForm.sbId,
              isAdmin: 0,
              isSystemUser: 0,
              orgId: departids.join(','),
              password: isfrom === 1 ? encode64(this.addForm.password || '') : encode64(this.addForm.newpassword || ''),
              roleId: roleids.join(','),
              salt: '',
              staffBirthday: '',
              staffCnName: this.addForm.staffCnName,
              staffCode: '',
              staffEmail: this.addForm.staffEmail,
              staffEnName: this.addForm.staffEnName,
              staffIdPic: '',
              staffMobilePhone: this.addForm.staffMobilePhone,
              staffName: this.addForm.staffName,
              staffPhone: '',
              staffSex: 0,
              staffState: 0,
              staffUserImage: ''
            }
            if (this.isfrom === 1) {
              const { data: res } = await this.$axios.post(
                '/api/staffBase/add',
                addForm
              )
              if (res.code === 200) {
                this.$message({
                  message: res.msg,
                  type: 'success'
                })
                this.addDialogVisible = false
                this.EmployeesList()
              } else {
                this.$message.error(res.msg)
              }
            } else {
              updateUserInfo(addForm).then(res => {
                this.$message({
                  message: res.data.msg,
                  type: res.data.code === 200 ? 'success' : 'error'
                })
                this.EmployeesList()
              })
            }
            this.addDialogVisible = false
            this.EmployeesList()
          }
        })
      },
      // 发起收款
      onInitiateCollection () {
        this.$router.push({ name: 'initiateCollection' })
      },
      // 设置头部背景色
      tableHeader ({ rowIndex }) {
        return this.$tableHeader(rowIndex)
      },
      // 收款申请详情
      onDetails () {
        this.$router.push({ name: 'collectionApplicationDetails' })
      },
      // 页数
      handleSizeChange (val) {
        this.size = val
        this.EmployeesList()
      },
      // 页码
      handleCurrentChange (val) {
        this.page = val
        this.EmployeesList()
      },
      onSearch () {
        const obj = []
        this.page = 1
        const { ruklepasm } = this
        for (var key in ruklepasm) {
          if (ruklepasm[key]) {
            obj.push({
              collection: true,
              column: key,
              endValue: '',
              value: ruklepasm[key],
              valueType: ''
            })
          }
        }
        // for (let index = 0; index < length; index++) {
        //   const params = {
        //     collection: true,
        //     column: _this.infotemp[index],
        //     endValue: '',
        //     value: ken[index],
        //     valueType: ''
        //   }
        //   obj.push(params)
        // }
        const temp = {
          criteriaVoList: [...obj]
        }

        this.queryCriteriaVo = temp
        this.EmployeesList()
      }
    },
    filters: {
      dateFilter
    }
  }

  function dateFilter (time) {
    const date = new Date(time)
    // eslint-disable-next-line no-undef
    return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
  }
</script>
<style
  lang="less"
  scoped>
  .updatepassword {
    position: relative;
  }

  .updateInfo {
    padding-left: 31px;
    .commInfo();
  }

  /deep/ .el-form-item__label {
    font-size: 14px;
    color: #4e555b;
    font-weight: normal;
  }

  .commInfo() {
    color: #4e555b;
    font-size: 16px;

    margin: 15px 0px 25px 0px;

    font-size: 16px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #4e555b;
  }

  .updateInfo_password {
    .commInfo();
  }

  .deletebtn {
    position: absolute;
    bottom: 1px;
    color: #d35e5e;
    right: -38px;
  }

  .poperClass {
    position: fixed;
    bottom: 39px;
    background-color: red;
  }

  .addgroupClass {
    color: #276cff;
    font-size: 14px;
  }

  .deleteClass {
    font-size: 14px;
    color: #d35e5e;
  }

  /deep/ .el-checkbox__label {
    color: #83878A !important;
  }

  /deep/ .el-cascader--mini {
    width: 92% !important;
  }

  .lpagination {
    padding: 0 20px !important;
  }

  * {
    touch-action: pan-y;
  }

</style>
